import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex, Heading, Text, Stack, HStack, RadioGroup, Radio, Icon, FormControl, FormLabel, Input, Button, IconButton, Tooltip, Box } from '@chakra-ui/react';
import { MdHelpOutline } from 'react-icons/md';
import {
  ApiComunication,
  getComunication,
  registerComunication
} from '../../../api/comunication';
import SettingsBreadcrumb from '../../../components/SettingsBreadcrumb';
import Swal from 'sweetalert2';
import './servico-comunicacao.scss'
import CustomInput from '../../../components/common/Input/input';
import { inserirPublicacao } from '../../../api/noticia';

const ServicoComunicacao = () => {
  const [typeOfService, setTypeOfService] = useState('none');
  const [sitServidor, setSitServidor] = useState<number>(0);
  const [isOpenTipoEmail, setIsOpenTipoEmail] = useState(false);
  const [isOpenEnderecoServidor, setIsOpenEnderecoServidor] = useState(false);
  const [isOpenPortaServidor, setIsOpenPortaServidor] = useState(false);
  const [isOpenUsuarioServidor, setIsOpenUsuarioServidor] = useState(false);
  const [isOpenSenhaServidor, setIsOpenSenhaServidor] = useState(false);
  const [isOpenRemetente, setIsOpenRemetente] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isFailureModalOpen, setIsFailureModalOpen] = useState(false);

  const navigate = useNavigate();

  const [formValues, setFormValues] = useState<{
    enderecoServidor: { value: string; error: boolean };
    usuarioAutenticar: { value: string; error: boolean };
    portaServidor: { value: string; error: boolean };
    senhaUsuarioAutenticar: { value: string; error: boolean };
    remetente: { value: string; error: boolean };
  }>({
    enderecoServidor: { value: '', error: false },
    usuarioAutenticar: { value: '', error: false },
    portaServidor: { value: '', error: false },
    senhaUsuarioAutenticar: { value: '', error: false },
    remetente: { value: '', error: false },
  });

  const handleServiceChange = (value: string) => {
    setTypeOfService(value);
    const newStatus = value === 'smtp' ? 1 : 0;
    setSitServidor(newStatus);
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getComunication();
        if (res) {

          setFormValues({
            enderecoServidor: {
              value: res.dsc_serv_endereco || '',
              error: false
            },
            usuarioAutenticar: {
              value: res.dsc_usuario || '',
              error: false
            },
            portaServidor: {
              value: res.dsc_serv_porta || '',
              error: false
            },
            senhaUsuarioAutenticar: {
              value: res.dsc_senha || '',
              error: false
            },
            remetente: {
              value: res.dsc_remetente || '',
              error: false
            }
          });

          const status = res.sit_servidor || 0;
          setSitServidor(status);
          setTypeOfService(status == "1" ? 'smtp' : 'none');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, []);

  const isFormValid = () => {
    const { enderecoServidor, usuarioAutenticar, portaServidor, senhaUsuarioAutenticar, remetente } = formValues;

    const isValid = (
      enderecoServidor.value &&
      usuarioAutenticar.value &&
      portaServidor.value &&
      senhaUsuarioAutenticar.value &&
      remetente.value
    );
    return isValid;
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const { enderecoServidor, usuarioAutenticar, portaServidor, senhaUsuarioAutenticar, remetente } = formValues;

    const params = {
      enderecoServidor: formValues.enderecoServidor.value || null,
      usuarioAutenticar: formValues.usuarioAutenticar.value || null,
      portaServidor: formValues.portaServidor.value || null,
      senhaUsuarioAutenticar: formValues.senhaUsuarioAutenticar.value || null,
      remetente: formValues.remetente.value || null,
    };

    try {
      await inserirPublicacao(params);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Noticia inserida com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/noticia');
      });
    } catch (error) {
      console.error('Erro ao inserir noticia:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao inserir noticia. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/noticia');
      });
    }
  };

  return (
    <Flex
      p="40px"
      bgColor="#fafafa"
      direction="column"
      w="100%"
      overflow='hidden'
    >
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Serviço de Comunicação
      </Heading>
      <Text mb="20px">
        Tipo de servidor de e-mail
        <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
        <Tooltip
          label="Grupo de dados para conectar ao servidor de e-mail utilizado para
              enviar notificações aos usuários"
          aria-label="Informação sobre o tipo de servidor de e-mail">
          <IconButton
            className='icones'
            variant='link'
            icon={<MdHelpOutline />}
            aria-label="Informação"
            size="md"
            color={'#2883de'} />
        </Tooltip>
      </Text>
      <Stack spacing={6}>
        <RadioGroup
          value={typeOfService}
          onChange={handleServiceChange}
        >
          <HStack spacing={3}>
            <Radio value="none">
              <Text>Não usamos</Text>
            </Radio>
            <Radio value="smtp">
              <Text>SMTP</Text>
            </Radio>
          </HStack>
        </RadioGroup>

        {typeOfService === 'smtp' && (
          <Box m="40px 0" w="100%">
            <form onSubmit={handleFormSubmit}>
              <div className="row">
                <div className="col-md-5 mb-4">
                  <FormControl>
                    <FormControl isInvalid={formValues.enderecoServidor.error}>
                      <FormLabel mb="8px">Endereço do servidor
                        <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                        <Tooltip
                          label="IP/URL do servidor que oferece o serviço de e-mail"
                          aria-label="Informação sobre o endereço do servidor">
                          <IconButton
                            className='icones'
                            icon={<MdHelpOutline />}
                            variant="link"
                            aria-label="Informação"
                            size="md"
                            color={'#2883de'}
                          />
                        </Tooltip>
                      </FormLabel>
                      <CustomInput
                        placeholder='Digite um endereço'
                        value={formValues.enderecoServidor.value}
                        onChange={(e: any) => handleFieldChange('enderecoServidor', e.target.value)}
                      />
                    </FormControl>

                  </FormControl>
                </div>
                <div className="col-md-3 mb-4">
                  <FormControl isInvalid={formValues.portaServidor.error}>
                    <FormLabel className='textos' mb="8px">Porta do Servidor
                      <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                      <Tooltip
                        label="Porta de conexão para o serviço de e-mail"
                        aria-label="Informação sobre a porta do servidor">
                        <IconButton
                          className='icones'
                          icon={<MdHelpOutline />}
                          variant="link"
                          aria-label="Informação"
                          size="md"
                          color={'#2883de'} />
                      </Tooltip>
                    </FormLabel>
                    <CustomInput
                      placeholder='Digite uma porta'
                      value={formValues.portaServidor.value}
                      onChange={(e: any) => handleFieldChange('portaServidor', e.target.value)}
                    />
                  </FormControl>
                </div>
                <div className="col-md-4 mb-4">
                  <FormControl isInvalid={formValues.usuarioAutenticar.error}>
                    <FormLabel mb="8px">Usuário para autenticar
                      <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                      <Tooltip
                        label="Usuário para acesso ao serviço de e-mail"
                        aria-label="Informação sobre usuário para autenticar">
                        <IconButton
                          className='icones'
                          icon={<MdHelpOutline />}
                          variant="link"
                          aria-label="Informação"
                          size="md"
                          color={'#2883de'} />
                      </Tooltip>
                    </FormLabel>
                    <CustomInput
                      placeholder='Digite um usuário'
                      value={formValues.usuarioAutenticar.value}
                      onChange={(e: any) => handleFieldChange('usuarioAutenticar', e.target.value)}
                    />
                  </FormControl>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-4">
                  <FormControl isInvalid={formValues.remetente.error}>
                    <FormLabel mb="8px">Identificação do remetente
                      <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                      <Tooltip
                        label={<Stack>
                          <Text>
                            Endereço de e-mail irá aparecer para o destinatário do
                            e-mail
                          </Text>
                          <Text >Exemplo: naoresponda@tecnogroup.com.br</Text>
                        </Stack>}
                        aria-label="Informação sobre a identificação do remetente">
                        <IconButton
                          className='icones'
                          icon={<MdHelpOutline />}
                          variant="link"
                          aria-label="Informação"
                          size="md"
                          color={'#2883de'} />
                      </Tooltip>
                    </FormLabel>
                    <CustomInput
                      placeholder='Digite uma identificação'
                      value={formValues.remetente.value}
                      onChange={(e: any) => handleFieldChange('remetente', e.target.value)}
                    />
                  </FormControl>
                </div>
                <div className="col-md-6 mb-4">
                  <FormControl isInvalid={formValues.senhaUsuarioAutenticar.error}>
                    <FormLabel className='textos' mb="8px">Senha do usuário para autenticar
                      <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                      <Tooltip
                        label="Senha do usuário para acesso ao serviço de e-mail"
                        aria-label="Informação sobre senha do usuário para autenticar">
                        <IconButton
                          className='icones'
                          icon={<MdHelpOutline />}
                          variant="link"
                          aria-label="Informação"
                          size="md"
                          color={'#2883de'} />
                      </Tooltip>
                    </FormLabel>
                    <CustomInput
                      placeholder='Digite uma senha'
                      value={formValues.senhaUsuarioAutenticar.value}
                      onChange={(e: any) => handleFieldChange('senhaUsuarioAutenticar', e.target.value)}
                      type="password"
                    />
                  </FormControl>
                </div>
              </div>
              <Flex mt="35px" justifyContent="end">
                <Button
                  m='6px'
                  onClick={() => {
                    navigate('/cms/configuracao');
                  }}
                >
                  Desistir
                </Button>
                <Button
                  type="submit"
                  m="6px"
                  color="#FFF"
                  bgColor="#1665D8"
                  _hover={{ opacity: 0.8 }}
                  // isDisabled={!isFormValid()}
                >
                  Salvar alterações
                </Button>
              </Flex>
            </form>
          </Box>
        )}
      </Stack>
    </Flex>
  );
}

export default ServicoComunicacao;
